const INVALID_CHECKOUT_REASONS = {
  UNSUPPORTED_ZIPCODE: 'zipcodeNoProvider',
} as const;

const CHECKOUT_CONTEXT = {
  InitialTreatment: 'initial-treatment',
  NewTreatment: 'new-treatment',
  TreatmentRenewal: 'treatment-renewal',
} as const;

export { INVALID_CHECKOUT_REASONS, CHECKOUT_CONTEXT };
